import React, { useState } from "react";
import {Grid, Typography, TextField, MenuItem} from '@mui/material'
import PropTypes from 'prop-types'
import LoadingPopUp from "../../../components/Pop_ups/LoadingPopUp";
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import OfferLetterUSA from "./OfferLetterUSA";
import OfferLetterCAN from "./OfferLetterCAN";

const fileTypes = ['docx', 'pdf']

/**
 * component used to create and send Offer Letters
 * @component 
 * @category Offer Letters
 * based off of ContractForm.js
 */

function OfferForm(props){
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [country, setCountry] = useState(null)

    const countries = ["Canada", "United States"]

    // when an offer letter is loaded, switch to its region's form during render so the other region's form never mounts with it
    const [shownLoad, setShownLoad] = useState(null)
    if (props.loadedOffer && props.loadedOffer !== shownLoad) {
        setShownLoad(props.loadedOffer)
        setCountry(props.loadedOffer.offer.region === 'CAN' ? "Canada" : "United States")
    }

    // remounting the form when an offer letter is loaded resets all of its state to the loaded values
    const formKey = props.loadedOffer ? props.loadedOffer.loadCount : 0
    const loadedOfferFor = (region) => props.loadedOffer && props.loadedOffer.offer.region === region ? props.loadedOffer : null

    return(
        <Grid sx={{ flexDirect: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', padding: '2%', height: '100%' }}>
            {error ? 
            <ErrorPopUp errorTitle = "Something has gone wrong" errorContent={error} />
            :
            <></>
            }
            
            <LoadingPopUp open={loading} />
            <Typography align='center' variant='h4'>Manage Offers</Typography>
            <Grid xs={3}>
            <TextField required label="Country" onChange={(e) => { e.preventDefault(); setCountry(e.target.value) }}
                value={country} fullWidth select>
                {countries.map((country) => (
                    <MenuItem key={country} value={country}>
                        {country}
                    </MenuItem>
                ))}
            </TextField>
            </Grid>
            {country === "United States" ?
            <OfferLetterUSA key={formKey} setError = {setError} {...props}authorities={props.authorities} clients={props.clients} states={props.states} venues={props.venues} contacts={props.contacts} recruiters={props.recruiters} accountManagers={props.accountManagers} signatories={props.signatories} setLoading = {setLoading} fileTypes = {fileTypes} loadedOffer={loadedOfferFor('USA')}></OfferLetterUSA>
            : <></>
            }
            {country === "Canada" ?
            <OfferLetterCAN key={formKey} setError = {setError}{...props} setLoading = {setLoading} fileTypes = {fileTypes} loadedOffer={loadedOfferFor('CAN')}></OfferLetterCAN>
            : <></>
            }
        </Grid>
    )

}

OfferForm.propTypes = {
    //based on ContractForm.js propTypes, unsure if more should be added...
    authorities: PropTypes.arrayOf(PropTypes.object).isRequired,
    clients: PropTypes.arrayOf(PropTypes.object),
    onComplete: PropTypes.func,
    onError: PropTypes.func,
    optionalFields: PropTypes.arrayOf(PropTypes.string),
    // previous offer letter to fill the form with: {offer, form, loadCount}
    loadedOffer: PropTypes.object
}

OfferForm.defaultProps = {
    onError: () => { },
    optionalFields: ['period_interval', 'period_length', 'benefit_narrative', 'overtime_narrative', 'address']
}

export default OfferForm